import { memo } from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import Button from "@mui/material/Button";
import { withSx } from "ui/atoms/Modal";
import { TriggerableDialog } from "ui/molecules/Dialog";
import {
    PaymentMethodDetail,
    PaymentMethodDetailProvider,
    usePaymentMethodContext
} from "../../PaymentMethod";

const AddPaymentMethod = () => {
    const {
        isProcessing,
        hasActiveChanges,
        updateOrCreate,
        reset
    } = usePaymentMethodContext();

    return (
        <TriggerableDialog
            TriggerComponent={({ onClick }) => (
                <LoadingButton
                    variant='contained'
                    color='secondary'
                    loading={isProcessing}
                    onClick={onClick}
                >
                    Add New Method
                </LoadingButton>
            )}
            DialogActionsComponent={({ onClose }) => (
                <>
                    <Button
                        onClick={onClose}
                    >
                        Cancel
                    </Button>
                    <LoadingButton
                        variant='contained'
                        onClick={async () => {
                            const result = await updateOrCreate();
                            if (result) {
                                onClose();
                            }
                        }}
                        loading={isProcessing}
                        disabled={!hasActiveChanges()}
                    >
                        Create Method
                    </LoadingButton>
                </>
            )}
            ModalProps={{
                disableCloseOnBackdropClick: true,
                onClose: reset,
                DialogProps: withSx({
                    maxWidth: 'lg'
                }),
                titleSlot: 'Add New Method'
            }}
        >
            <PaymentMethodDetail />
        </TriggerableDialog>
    );
};

export default memo(() => (
    <PaymentMethodDetailProvider
        useCaseDiscriminationKey='create'
    >
        <AddPaymentMethod />
    </PaymentMethodDetailProvider>
));
